module.exports = __webpack_public_path__ + "static/media/realtalk_sd_aoi_danceb5494bf23366d1bf3f8b094103fd9672.webp";